import { Input, Popover } from '@any-ui-react/core';
import { YearPicker as MantineYearPicker } from '@mantine/dates';
import { format } from 'date-fns';
import { useState } from 'react';

import { DateUtils } from '@/common/utils';

interface Props {
  disabled?: boolean;
  label?: string;
  maxDate?: Date;
  minDate?: Date;
  value: string;
  withinPortal?: boolean;
  onChange: (value: string) => void;
}

export const YearPicker = ({ disabled, label, maxDate, minDate, value, withinPortal, onChange }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover
      closeOnClickOutside={true}
      disabled={disabled}
      offset={0}
      opened={isOpen}
      position="bottom-start"
      withinPortal={withinPortal}
      onChange={setIsOpen}
    >
      <Popover.Target>
        <Input.Wrapper onClick={() => setIsOpen(prev => !prev)}>
          {label && <Input.Label>{label}</Input.Label>}
          <Input
            classNames={{ input: 'text-center cursor-pointer' }}
            disabled={disabled}
            readOnly={true}
            value={value}
          />
        </Input.Wrapper>
      </Popover.Target>

      <Popover.Dropdown className="absolute max-h-[26rem] rounded border border-gray-2 bg-white shadow-sm">
        <MantineYearPicker
          className="bg-white"
          defaultDate={DateUtils.coalesce(value)}
          maxDate={maxDate}
          minDate={minDate}
          value={DateUtils.coalesce(value)}
          onChange={v => {
            if (v) {
              onChange(format(v, 'yyyy'));
              setIsOpen(false);
            }
          }}
        />
      </Popover.Dropdown>
    </Popover>
  );
};
